import React, {useEffect, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { FEATURES, SITEHEADERDATA, TOPMENUDATA, TRANSLATION } from '../constants/state'
import SkipToMainAccess from '../Accessibility/Skip/SkipToMainAccess'
import SiteNavigationAccess from './SiteNavigationAccess'
import UserContentAccess from './UserContentAccess'




const mapStateToProps = (state, ownProps) => ({
    siteHeaderData: getData(state, SITEHEADERDATA),
    // features: getData(state, FEATURES),
})


const SiteHeaderAccess = ({
    siteHeaderData,
    // features
}) => {
    const { homeURL, siteName } = siteHeaderData

    return (
        <header className="theme-access access-site-header" role="banner">
            <div className="grid-site-wrapper">
                <SkipToMainAccess />

                <h1>
                    <a href={homeURL} rel="home" className="title-xxlarge access-typo">{siteName}</a>
                </h1> 

                <SiteNavigationAccess />

                {/* {features && features.has_userbar && <UserContentAccess />} */}
            </div>
        </header>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SiteHeaderAccess)